import { firstValueSeen } from "../lib/completion-analytics";
import {
	cinemaPosition,
	rowOrdinal,
	seatFacts,
	seatLayoutFor,
	type SeatCandidate,
} from "@anjabom/core";
import { useEffect, useState } from "react";
import { ExternalLink } from "./ExternalLink";

export function SeatFactsCard({
	candidate,
	compact = false,
}: {
	candidate: Pick<
		SeatCandidate,
		"venueId" | "spaceId" | "sectionCode" | "rowLabel" | "seatNumber"
	>;
	compact?: boolean;
}) {
	const layout = seatLayoutFor(candidate.venueId, candidate.spaceId);
	const [rows, setRows] = useState(""),
		[seats, setSeats] = useState("");
	useEffect(() => {
		if (layout) firstValueSeen();
	}, [layout]);
	if (!layout) return null;
	const facts = seatFacts(
		layout,
		candidate.sectionCode,
		candidate.rowLabel,
		candidate.seatNumber,
	);
	const relative = cinemaPosition(
		rowOrdinal(candidate.rowLabel) ?? 0,
		candidate.seatNumber,
		Number(rows),
		Number(seats),
	);
	return (
		<section className={`seat-facts stack${compact ? " seat-facts-compact" : ""}`} aria-label="공식 좌석 사실">
			{compact ? <h3>공식 자료로 확인한 위치</h3> : <h2>공식 자료로 확인한 위치</h2>}
			<ul>
				{facts.lines.map((line) => (
					<li key={line}>{line}</li>
				))}
			</ul>
			{layout.precision === "booking" ? (
				<div className="stack">
					<p>
						예매 화면의 전체 열 수와 이 열의 좌석 수를 넣으면 상대 위치를
						계산해요. 이 기기 밖으로 보내지 않아요.
					</p>
					<label className="field">
						전체 열 수
						<input
							className="input"
							inputMode="numeric"
							value={rows}
							onChange={(e) => setRows(e.target.value)}
						/>
					</label>
					<label className="field">
						이 열 좌석 수
						<input
							className="input"
							inputMode="numeric"
							value={seats}
							onChange={(e) => setSeats(e.target.value)}
						/>
					</label>
					{relative ? <p>{relative}</p> : null}
				</div>
			) : null}
			<p className="micro">
				<ExternalLink href={layout.source.url}>
					{layout.source.label}
				</ExternalLink>{" "}
				· {layout.source.checkedAt} 확인
			</p>
			{!compact ? <p className="micro">
				위치는 공식 자료의 사실이에요. 실제 시야와 이번 공연의 무대 구성은
				앉아본 기록과 별도로 확인해요.
			</p> : null}
		</section>
	);
}
